function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SegmentIntersector from './SegmentIntersector';
var IntersectionAdder = /*#__PURE__*/function () {
  function IntersectionAdder() {
    _classCallCheck(this, IntersectionAdder);
    IntersectionAdder.constructor_.apply(this, arguments);
  }
  return _createClass(IntersectionAdder, [{
    key: "isTrivialIntersection",
    value: function isTrivialIntersection(e0, segIndex0, e1, segIndex1) {
      if (e0 === e1) {
        if (this._li.getIntersectionNum() === 1) {
          if (IntersectionAdder.isAdjacentSegments(segIndex0, segIndex1)) return true;
          if (e0.isClosed()) {
            var maxSegIndex = e0.size() - 1;
            if (segIndex0 === 0 && segIndex1 === maxSegIndex || segIndex1 === 0 && segIndex0 === maxSegIndex) {
              return true;
            }
          }
        }
      }
      return false;
    }
  }, {
    key: "getProperIntersectionPoint",
    value: function getProperIntersectionPoint() {
      return this._properIntersectionPoint;
    }
  }, {
    key: "hasProperInteriorIntersection",
    value: function hasProperInteriorIntersection() {
      return this._hasProperInterior;
    }
  }, {
    key: "getLineIntersector",
    value: function getLineIntersector() {
      return this._li;
    }
  }, {
    key: "hasProperIntersection",
    value: function hasProperIntersection() {
      return this._hasProper;
    }
  }, {
    key: "processIntersections",
    value: function processIntersections(e0, segIndex0, e1, segIndex1) {
      if (e0 === e1 && segIndex0 === segIndex1) return null;
      this.numTests++;
      var p00 = e0.getCoordinates()[segIndex0];
      var p01 = e0.getCoordinates()[segIndex0 + 1];
      var p10 = e1.getCoordinates()[segIndex1];
      var p11 = e1.getCoordinates()[segIndex1 + 1];
      this._li.computeIntersection(p00, p01, p10, p11);
      if (this._li.hasIntersection()) {
        this.numIntersections++;
        if (this._li.isInteriorIntersection()) {
          this.numInteriorIntersections++;
          this._hasInterior = true;
        }
        if (!this.isTrivialIntersection(e0, segIndex0, e1, segIndex1)) {
          this._hasIntersection = true;
          e0.addIntersections(this._li, segIndex0, 0);
          e1.addIntersections(this._li, segIndex1, 1);
          if (this._li.isProper()) {
            this.numProperIntersections++;
            this._hasProper = true;
            this._hasProperInterior = true;
          }
        }
      }
    }
  }, {
    key: "hasIntersection",
    value: function hasIntersection() {
      return this._hasIntersection;
    }
  }, {
    key: "isDone",
    value: function isDone() {
      return false;
    }
  }, {
    key: "hasInteriorIntersection",
    value: function hasInteriorIntersection() {
      return this._hasInterior;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IntersectionAdder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [SegmentIntersector];
    }
  }], [{
    key: "isAdjacentSegments",
    value: function isAdjacentSegments(i1, i2) {
      return Math.abs(i1 - i2) === 1;
    }
  }]);
}();
export { IntersectionAdder as default };
IntersectionAdder.constructor_ = function () {
  this._hasIntersection = false;
  this._hasProper = false;
  this._hasProperInterior = false;
  this._hasInterior = false;
  this._properIntersectionPoint = null;
  this._li = null;
  this._isSelfIntersection = null;
  this.numIntersections = 0;
  this.numInteriorIntersections = 0;
  this.numProperIntersections = 0;
  this.numTests = 0;
  var li = arguments[0];
  this._li = li;
};